<template>

    <div class="card_error_outputs">

    </div>

</template>

<script>
export default {

}
</script>

<style>
    .card_error_outputs {
        position: absolute;
        inset: 0;
        z-index: 1;
        background: url(../assets/cf-watermark-square.svg) repeat;
        background-size: 35px;
        opacity: 1;
    }
</style>